import { FeeScheduleView } from './types/contractTypes';

export const createDefaultFeeSchedule = (contractId: string = ''): FeeScheduleView => {
  return {
    id: '',
    contractId,
    description: '',
    effectiveDate: null,
    endDate: null,
    feeType: '',
    feeSubType: '',
    category: '',
    feeSummary: {
      createDate: null,
      lastUpdate: null,
      uploadInProgress: false,
      isLastUploadSuccess: null,
      uploadErrorMessage: '',
      submittedForDelete: false,
      successful: 0,
      failed: 0,
      total: 0,
      errors: []
    },
    groupers: [],
    revCodeRestrictions: [],
  };
};
